import React from "react";
import get from "lodash/get";
import { SvgHandler } from "../../../svg-handler/svg-handler";
import success from "../../../../../assets/icons/success.svg";
import { getTextContrast } from "../../../../utils";
import "./success.m.css";
import { useSelector } from "react-redux";

export const SubscriptionSuccess = (props) => {
  const { primaryColor = "#3cab92", darkPrimaryColor = "#3cab92" } = get(
    props,
    ["config", "pagebuilder-config", "general"],
    {}
  );
  const enableDarkMode = useSelector((state) => get(state, ["header", "isDarkModeEnabled"], false));
  const updatedPrimaryColor = enableDarkMode ? darkPrimaryColor : primaryColor;
  const homeBtnTheme = getTextContrast(updatedPrimaryColor);
  return (
    <div styleName="wrapper">
      <SvgHandler xlinkHref={success} width="24" height="24" viewBox="0 0 24 24" clazzName={""} />
      <div styleName="title">Thank you for placing your order!</div>
      <div styleName="content">
        We kindly ask for your patience as we process it <span styleName="wrap-content">(approx. 15 min).</span> Please
        check your email for further details and updates.
      </div>
      <div styleName="button-wrapper">
        <a href="/" style={{ color: homeBtnTheme === "dark" ? "#000" : "#fff" }}>
          Go to Home
        </a>
        <a href="/user-details">Go to Profile</a>
      </div>
    </div>
  );
};
